export default __webpack_public_path__ + "static/media/hands-08_01.a1791852.png";